export class NumberChecker {
  /**
   * Проверяет email на корректность
   * @param email - строка адреса электронной почты
   * @returns {boolean}
   */
  checkMinValue (value: number, refNumber: number) {
    return value >= refNumber
  }

  /**
   * Проверяет email на корректность
   * @param email - строка адреса электронной почты
   * @returns {boolean}
   */
  checkMaxValue (value: number, refNumber: number) {
    return value <= refNumber
  }

  /**
   * Проверяет максимальное количество записей
   * @param value
   * @param refNumber
   */
  static checkMaxCount (value: number, refNumber: number): boolean {
    return value <= refNumber
  }

  /**
   * Проверяет на минимальное количество записей
   * @param value
   * @param refNumber
   */
  static checkMinCount (value: number, refNumber: number): boolean {
    return value >= refNumber
  }
}
